import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../ui/button';
import './page-design.css';

/**
 * Shared Trainnova page header. The Training overview is the visual reference.
 * Pages continue to own actions, permissions, navigation and tab state.
 * Legacy PageHeader entry points delegate here to keep a single visual source.
 */
const DetailPageHeader = ({
  title,
  subtitle,
  description,
  icon: Icon,
  count,
  onBack,
  actions = null,
  children,
  status = null,
  tabs = null,
  className = '',
  testId = 'detail-page-header',
}) => {
  const supportingText = subtitle || description;
  const headerActions = children || actions;

  return (
    <section className={`tn-page-header ${className}`} data-testid={testId}>
      <div className="tn-page-header__row">
        <div className="tn-page-header__identity">
          {onBack ? (
            <Button
              type="button"
              variant="ghost"
              size="icon"
              onClick={onBack}
              className="tn-page-header__back"
              aria-label="Tillbaka"
            >
              <ArrowLeft className="h-4 w-4" />
            </Button>
          ) : null}

          <div className="tn-page-header__text">
            <div className="tn-page-header__title-line">
              {Icon ? <Icon className="tn-page-header__icon" aria-hidden="true" /> : null}
              <h1 className="tn-page-header__title">{title}</h1>
              {count !== undefined && count !== null ? (
                <span className="tn-page-header__count">({count})</span>
              ) : null}
            </div>
            {supportingText ? (
              <p className="tn-page-header__subtitle">{supportingText}</p>
            ) : null}
          </div>
        </div>

        {headerActions ? (
          <div className="tn-page-header__actions">{headerActions}</div>
        ) : null}
      </div>

      {status ? <div className="tn-page-header__status">{status}</div> : null}
      {tabs ? <div className="tn-page-header__tabs">{tabs}</div> : null}
    </section>
  );
};

export default DetailPageHeader;
